<template>
  <div class="tile">
    <p class="text__center text__bold">State Licenses</p>
    <div v-if="!editing">
      <p
        v-if="!active.licenses || active.licenses.length === 0"
        class="flex__center lender--placeholder"
      >{{ active.display_name }} is not licensed in any state</p>
      <div v-else>
        <p class="text__center">{{ active.display_name }} is licensed in the following states:</p>
        <simplebar class="lender--overflow" data-simplebar-auto-hide="false">
          <ul class="licenses--list-show mb-15 mt-15">
            <li v-for="license in sortedLicenses" :key="license._id" class="lender--list-item">
              <span class="text__dark">&bull;</span>
              <span>{{ license.state }}</span>
            </li>
          </ul>
        </simplebar>
      </div>
    </div>
    <div v-else class="lender--edit m-tb-small">
      <label class="flex__center">
        Search:
        <input
          type="text"
          v-model="stateSearch"
          name="stateSearch"
          placeholder="state name"
          class="list--search ml-10"
          ref="search"
        />
      </label>
      <simplebar class="lender--overflow" data-simplebar-auto-hide="false">
        <ul class="lender--edit-list">
          <li class="lender--edit-item" v-for="state in getStates" :key="state.short">
            <input
              class="licenses--list-check"
              type="checkbox"
              :value="state"
              v-model="form.licenses"
              :name="state.short"
              :id="state.short"
            />
            <label :for="state.short">{{ state.state }}</label>
          </li>
        </ul>
      </simplebar>
    </div>
    <div v-if="!editing" class="flex__center pt-15">
      <button class="btn btn__green" @click="toggleEditing">Edit</button>
    </div>
    <div v-else class="flex__between pt-15">
      <button class="btn btn__red" @click="toggleEditing">Cancel</button>
      <button class="btn btn__green" @click="submitStates">Submit</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["active"],
  data() {
    return {
      editing: false,
      stateSearch: "",
      form: {
        ...this.active,
        licenses: this.active.licenses.map(st => ({
          short: st.short,
          state: st.state
        }))
      },
      states: [
        {
          short: "AL",
          state: "Alabama"
        },
        {
          short: "AK",
          state: "Alaska"
        },
        {
          short: "AZ",
          state: "Arizona"
        },
        {
          short: "AR",
          state: "Arkansas"
        },
        {
          short: "CA",
          state: "California"
        },
        {
          short: "CO",
          state: "Colorado"
        },
        {
          short: "CT",
          state: "Connecticut"
        },
        {
          short: "DE",
          state: "Delaware"
        },
        {
          short: "DC",
          state: "District Of Columbia"
        },
        {
          short: "FL",
          state: "Florida"
        },
        {
          short: "GA",
          state: "Georgia"
        },
        {
          short: "HI",
          state: "Hawaii"
        },
        {
          short: "ID",
          state: "Idaho"
        },
        {
          short: "IL",
          state: "Illinois"
        },
        {
          short: "IN",
          state: "Indiana"
        },
        {
          short: "IA",
          state: "Iowa"
        },
        {
          short: "KS",
          state: "Kansas"
        },
        {
          short: "KY",
          state: "Kentucky"
        },
        {
          short: "LA",
          state: "Louisiana"
        },
        {
          short: "ME",
          state: "Maine"
        },
        {
          short: "MD",
          state: "Maryland"
        },
        {
          short: "MA",
          state: "Massachusetts"
        },
        {
          short: "MI",
          state: "Michigan"
        },
        {
          short: "MN",
          state: "Minnesota"
        },
        {
          short: "MS",
          state: "Mississippi"
        },
        {
          short: "MO",
          state: "Missouri"
        },
        {
          short: "MT",
          state: "Montana"
        },
        {
          short: "NE",
          state: "Nebraska"
        },
        {
          short: "NV",
          state: "Nevada"
        },
        {
          short: "NH",
          state: "New Hampshire"
        },
        {
          short: "NJ",
          state: "New Jersey"
        },
        {
          short: "NM",
          state: "New Mexico"
        },
        {
          short: "NY",
          state: "New York"
        },
        {
          short: "NC",
          state: "North Carolina"
        },
        {
          short: "ND",
          state: "North Dakota"
        },
        {
          short: "OH",
          state: "Ohio"
        },
        {
          short: "OK",
          state: "Oklahoma"
        },
        {
          short: "OR",
          state: "Oregon"
        },
        {
          short: "PA",
          state: "Pennsylvania"
        },
        {
          short: "RI",
          state: "Rhode Island"
        },
        {
          short: "SC",
          state: "South Carolina"
        },
        {
          short: "SD",
          state: "South Dakota"
        },
        {
          short: "TN",
          state: "Tennessee"
        },
        {
          short: "TX",
          state: "Texas"
        },
        {
          short: "UT",
          state: "Utah"
        },
        {
          short: "VT",
          state: "Vermont"
        },
        {
          short: "VA",
          state: "Virginia"
        },
        {
          short: "WA",
          state: "Washington"
        },
        {
          short: "WV",
          state: "West Virginia"
        },
        {
          short: "WI",
          state: "Wisconsin"
        },
        {
          short: "WY",
          state: "Wyoming"
        }
      ]
    };
  },
  watch: {
    watchedLicenses() {
      this.form.licenses = this.active.licenses.map(st => ({
        short: st.short,
        state: st.state
      }));
    }
  },
  computed: {
    getStates() {
      if (this.stateSearch) {
        return this.states.filter(state => {
          return (
            state.short
              .toLowerCase()
              .includes(this.stateSearch.toLowerCase()) ||
            state.state.toLowerCase().includes(this.stateSearch.toLowerCase())
          );
        });
      } else {
        return this.states;
      }
    },
    sortedLicenses() {
      return [...this.active.licenses].sort((a, b) => {
        if (a.state > b.state) {
          return 1;
        } else if (a.state < b.state) {
          return -1;
        } else {
          return 0;
        }
      });
    },
    watchedLicenses() {
      return this.active.licenses;
    }
  },
  methods: {
    ...mapActions({
      startUpdateLoanOfficer: "loanOfficers/startUpdateLoanOfficer"
    }),
    toggleEditing() {
      this.stateSearch = "";
      this.editing = !this.editing;
      this.$nextTick(() => {
        return this.editing ? this.$refs.search.focus() : null;
      });
    },
    async submitStates() {
      if (this.active) {
        await this.startUpdateLoanOfficer(this.form);
        this.toggleEditing();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.licenses--list-show {
  @include grid($cols: repeat(2, 1fr), $col-gap: 30px, $row-gap: 10px);
}
@media (min-width: $md) {
  .licenses--list-show {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>